/**
 * Returns CSS class names for plan badges based on the plan name
 * @param plan The plan name (e.g., 'Amplr Start', 'Amplr Max', 'Amplr Pro')
 * @returns CSS class names for styling the plan badge
 */
export const getPlanBadgeStyles = (plan: string | null): string => {
  if (!plan) return '';
  
  switch (plan.replace('Amplr ', '')) {
    case 'Start':
      return 'bg-blue-500/10 text-blue-500';
    case 'Max':
      return 'bg-yellow-500/10 text-yellow-500';
    case 'Pro':
      return 'bg-gray-900/10 text-gray-900 dark:bg-gray-200/10 dark:text-gray-200';
    default:
      return 'bg-orange-500/10 text-orange-500';
  }
};